"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entry = Entry;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var content_1 = require("./components/dialogs/content");
var message_1 = require("./components/dialogs/message");
var footer_1 = require("./components/footer");
var header_1 = require("./components/header");
var clinics_1 = require("./pages/clinics");
var find_store_1 = require("./pages/find-store");
var home_1 = require("./pages/home");
var login_1 = require("./pages/login");
var qr_landing_1 = require("./pages/qr-landing");
var rewards_1 = require("./pages/rewards");
var sign_up_1 = require("./pages/sign-up");
var stats_1 = require("./pages/stats");
var KNOWN_ROUTES = ["/login", "/sign-up", "/home", "/clinics", "/rewards", "/find-store"];
var isStatsHost = function (hostname) {
    return /^[a-z0-9-]+\.([a-z0-9-]+\.)?run\.app$/.test(hostname) || ["localhost", "127.0.0.1", "[::1]"].includes(hostname);
};
function Entry() {
    var location = (0, react_router_dom_1.useLocation)();
    var showStats = isStatsHost(window.location.hostname);
    var routes = (0, react_router_dom_1.useRoutes)(__spreadArray(__spreadArray([
        { path: "/", element: (0, jsx_runtime_1.jsx)(qr_landing_1.QrLandingPage, {}) },
        { path: "/cyprus/*", element: (0, jsx_runtime_1.jsx)(qr_landing_1.QrLandingPage, { cyprus: true }) },
        { path: "login", element: (0, jsx_runtime_1.jsx)(login_1.LoginPage, {}) },
        { path: "sign-up", element: (0, jsx_runtime_1.jsx)(sign_up_1.SignUpPage, {}) },
        { path: "home", element: (0, jsx_runtime_1.jsx)(home_1.HomePage, {}) },
        { path: "clinics", element: (0, jsx_runtime_1.jsx)(clinics_1.ClinicsPage, {}) },
        { path: "rewards", element: (0, jsx_runtime_1.jsx)(rewards_1.RewardsPage, {}) },
        { path: "find-store", element: (0, jsx_runtime_1.jsx)(find_store_1.FindStorePage, {}) }
    ], (!showStats ? [] : [
        { path: "stats", element: (0, jsx_runtime_1.jsx)(stats_1.StatsPage, {}) },
        { path: "cyprus/stats", element: (0, jsx_runtime_1.jsx)(stats_1.StatsPage, { region: "cyprus" }) },
    ]), true), [
        //
        // Catch-all: any unknown route renders the QR landing page
        // so deep link paths like /hello/world?x=1 are handled
        //
        { path: "/*", element: (0, jsx_runtime_1.jsx)(qr_landing_1.QrLandingPage, {}) },
    ], false));
    var isFullScreenRoute = !KNOWN_ROUTES.some(function (r) { return location.pathname.startsWith(r); });
    if (isFullScreenRoute) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: routes });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-screen min-w-[550px] flex-col items-center", children: [(0, jsx_runtime_1.jsx)(header_1.Header, {}), (0, jsx_runtime_1.jsx)("div", { className: "container min-h-[100px] flex-1 px-6 py-4", children: routes }), (0, jsx_runtime_1.jsx)(footer_1.Footer, {}), (0, jsx_runtime_1.jsx)(content_1.ContentDialog, {}), (0, jsx_runtime_1.jsx)(message_1.MessageDialog, {})] }));
}
